import dayjs from 'dayjs';
import { formatDate } from '@frontend/date';

type RuleExceptionPastCheckValues = {
  isAllDay?: boolean;
  isRecurring?: boolean;
  startDate?: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
};

export const getIsPastException = (values: RuleExceptionPastCheckValues): boolean => {
  if (!values.startDate) return false;

  try {
    const endDateValue = values.isRecurring ? values.endDate : values.endDate || values.startDate;
    const endTimeValue = values.isAllDay ? '23:59' : values.endTime;
    const endDateTime = dayjs(`${endDateValue} ${endTimeValue}`, 'MM/DD/YYYY HH:mm');

    return endDateTime.isValid() && endDateTime.isBefore(dayjs());
  } catch (error) {
    console.error('Error evaluating past exception state:', error);
    return false;
  }
};

export const formatExceptionTimeRangeString = (time?: string) => {
  if (!time) return null;
  const datetime = dayjs(time, 'HH:mm');
  if (!datetime.isValid()) return null;
  return datetime.format('h:mm A');
};

export const formatExceptionDateString = (value?: string, timezone?: string, outputFormat = 'MMMM D, YYYY') => {
  if (!value) return null;

  try {
    return dayjs(value).tz(timezone).format(outputFormat);
  } catch (error) {
    console.error('Error parsing date string:', error);
    return formatDate(value, outputFormat);
  }
};
